import React, { useState, useEffect, createContext, useContext } from "react";
import { useDispatch } from "react-redux";
import { setConfig as setReduxConfig } from "./../redux/slices/configSlice"; 

export const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    fetch(`/config.json?timestamp=${new Date().getTime()}`)
      .then((response) => response.json())
      .then((data) => {
        document.documentElement.setAttribute("data-project", data.project);
        setConfig(data);
        dispatch(setReduxConfig(data));
        loadStyles(data);
      })
      .catch((error) => console.error("Error loading configuration:", error.message));
  }, [dispatch]);

  const loadStyles = (configData) => {
    if (!configData?.styles || !Array.isArray(configData.styles)) return;

    // Remove previously loaded project-specific styles
    document.querySelectorAll("link[data-dynamic-style]").forEach((link) => {
      link.parentNode.removeChild(link);
    });
  
    // Load the new styles for the selected project
    configData.styles.forEach((stylePath) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = `${stylePath}?timestamp=${new Date().getTime()}`;
      link.setAttribute("data-dynamic-style", "true"); // Mark it as dynamically added
      document.head.appendChild(link);
    });
  };

  if (!config) {
    return <div>Loading configuration...</div>;
  }

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}



